export default __webpack_public_path__ + "static/media/AW.0be2292a.svg";